import { ScrollArea as MantineScrollArea } from '@mantine/core'

import type { ScrollAreaProps } from '@/components/ScrollArea/ScrollArea.types'

import classes from './ScrollArea.module.css'

export function ScrollArea({
  children,
  ...props
}: ScrollAreaProps): JSX.Element {
  return (
    <MantineScrollArea
      classNames={classes}
      offsetScrollbars
      scrollbarSize={6}
      type="auto"
      {...props}
    >
      {children}
    </MantineScrollArea>
  )
}
